import { useEffect, useMemo, useState } from "react";
import { supabase } from "./supabaseClient";

const REASON_LABELS = {
  cerrado: "Lugar cerrado / ya no existe",
  info_incorrecta: "Información incorrecta / corrección",
};

export const reportReasonLabel = reason => REASON_LABELS[reason] || String(reason || "Sin motivo").replace(/_/g, " ");

export default function AdminReportsPanel({ places = [] }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showResolved, setShowResolved] = useState(false);
  const [workingId, setWorkingId] = useState(null);

  const load = async () => {
    setLoading(true); setError("");
    const { data, error: queryError } = await supabase
      .from("reportes")
      .select("id,place_id,motivo,user_id,fecha,atendido")
      .order("fecha", { ascending: false });
    if (queryError) { setReports([]); setError("No se pudieron consultar los reportes: " + queryError.message); }
    else setReports(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const placeNames = useMemo(() => new Map(places.map(place => [Number(place.id), place.name])), [places]);
  const pendingCount = reports.filter(report => !report.atendido).length;
  const visible = showResolved ? reports : reports.filter(report => !report.atendido);

  const markResolved = async report => {
    setWorkingId(report.id); setError("");
    const { error: mutationError } = await supabase.from("reportes").update({ atendido: true }).eq("id", report.id);
    if (mutationError) setError("No se pudo marcar el reporte como atendido: " + mutationError.message);
    else setReports(current => current.map(item => item.id === report.id ? { ...item, atendido: true } : item));
    setWorkingId(null);
  };

  return <section aria-label="Reportes de lugares" style={{ marginTop: 28, paddingTop: 22, borderTop: "1px solid #2a2a2a" }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 12 }}>
      <div>
        <h2 style={{ margin: 0, color: "#fff", fontSize: 18 }}>Reportes de lugares</h2>
        <p style={{ margin: "4px 0 0", color: pendingCount ? "#e57373" : "#666", fontSize: 11 }}>{pendingCount} pendiente{pendingCount === 1 ? "" : "s"} de atención</p>
      </div>
      <button type="button" onClick={() => setShowResolved(value => !value)} style={{ background: "#161616", border: "1px solid #333", color: "#bbb", borderRadius: 9, padding: "8px 10px", fontSize: 10, cursor: "pointer" }}>{showResolved ? "Solo pendientes" : "Ver historial"}</button>
    </div>

    {loading && <p role="status" style={{ color: "#888", fontSize: 12 }}>Cargando reportes…</p>}
    {error && <div role="alert" style={{ background: "#321717", border: "1px solid #5a2d2d", color: "#ef9a9a", borderRadius: 10, padding: 10, fontSize: 11, marginBottom: 10 }}>{error}</div>}
    {!loading && !error && visible.length === 0 && <p style={{ color: "#666", fontSize: 12 }}>{showResolved ? "No hay reportes registrados." : "No hay reportes pendientes."}</p>}

    <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
      {visible.map(report => {
        const placeName = placeNames.get(Number(report.place_id)) || `Lugar #${report.place_id}`;
        return <article key={report.id} style={{ background: "#111", border: `1px solid ${report.atendido ? "#252525" : "#4a2727"}`, borderRadius: 12, padding: "12px 13px", opacity: report.atendido ? 0.7 : 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 10, marginBottom: 6 }}>
            <strong style={{ color: "#fff", fontSize: 12 }}>{placeName}</strong>
            <span style={{ color: report.atendido ? "#81c784" : "#e57373", fontSize: 9, fontWeight: 800 }}>{report.atendido ? "ATENDIDO" : "PENDIENTE"}</span>
          </div>
          <p style={{ margin: "0 0 7px", color: "#ccc", fontSize: 11 }}>{reportReasonLabel(report.motivo)}</p>
          <div style={{ color: "#666", fontSize: 9, lineHeight: 1.5, wordBreak: "break-word" }}>
            <div>{report.fecha ? new Date(report.fecha).toLocaleString() : "Sin fecha"}</div>
            <div>{report.user_id ? `Usuario: ${report.user_id}` : "Reporte anónimo"}</div>
          </div>
          {!report.atendido && <button type="button" disabled={workingId === report.id} onClick={() => markResolved(report)} style={{ width: "100%", marginTop: 9, background: "#182318", border: "1px solid #2d5a2d", borderRadius: 8, color: "#81c784", padding: "7px 9px", fontSize: 10, fontWeight: 800, cursor: workingId === report.id ? "wait" : "pointer" }}>{workingId === report.id ? "Guardando…" : "✓ Marcar atendido"}</button>}
        </article>;
      })}
    </div>
  </section>;
}
